import { useChargePoints } from '@/features/charge-points/hooks/useChargePoints';
import { useUiModeStore } from '@/features/ui-mode/store/ui-mode-store';

export function LoadingLine() {
  const { isFetching } = useChargePoints();
  const loaderColor = useUiModeStore((s) => s.loaderColor);

  if (!isFetching) return null;

  const color = loaderColor ?? 'var(--operator-primary-color, #000000)';

  return (
    <div
      role="progressbar"
      aria-label="Loading charge points"
      aria-busy="true"
      className="fixed top-0 left-0 right-0 h-[3px] z-[9999] overflow-hidden pointer-events-none"
    >
      <div
        className="absolute inset-y-0 w-1/3 animate-loader-sweep"
        style={{ background: color }}
      />
    </div>
  );
}
